import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "the-tales-of-beedle-the-bard-v1-grade-b",
  name: "The Tales of Beedle the Bard V1 (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Tales of Beedle the Bard V1",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
